export default __webpack_public_path__ + "static/thebottomline13-5f4fb99a90bc5e9fb16747d0fad11b00.jpg";